import { render, staticRenderFns } from "./MFormCheckbox.vue?vue&type=template&id=24cb5b00&"
import script from "./MFormCheckbox.vue?vue&type=script&lang=js&"
export * from "./MFormCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports